import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
export function SocialProof() {
  const reviews = [{
    quote: 'I came to them with an EV problem that they had not experienced before... I could have gone directly to Tesla, but I am confident the level of individual services I received from Lancers would not have been achieved had I gone to the OEM. I will be using Lancer and recommend them to anyone who asks.',
    author: 'Robert B.'
  }, {
    quote: "Lancer was referred to me by my previous service center. I'm extremely satisfied with the service I've received here. The team goes above and beyond compared to most dealerships/service centers I've dealt with in the past... I have full trust in this team and am so glad that I was referred to Lancer!",
    author: 'Shanna'
  }, {
    quote: "From start to finish, they were professional, honest, and a true pleasure to work with. They were right on time, kept us informed, and went above and beyond — even telling us we didn't need a service we originally came in for, which saved us money. That kind of honesty is rare and so appreciated!",
    author: 'De B.'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-214">
      <div className="max-w-6xl mx-auto" data-id="element-215">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-216">
          <span className="uppercase tracking-widest text-sm font-bold text-brand-accent mb-4 block" data-id="element-217">
            Customer reviews
          </span>
          <h2 className="font-heading uppercase tracking-wide text-3xl md:text-4xl lg:text-5xl font-extrabold text-brand-dark mb-6" data-id="element-218">
            Trusted by St. Paul drivers for nearly 50 years
          </h2>
          <div className="flex items-center justify-center gap-3 text-xl font-bold text-brand-dark" data-id="element-219">
            <span data-id="element-220">4.9</span>
            <div className="flex text-brand-gold" data-id="element-221">
              {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-6 h-6 fill-current" data-id="element-222" />)}
            </div>
            <span className="text-gray-500 font-medium text-lg" data-id="element-223">
              Based on 595 Google reviews
            </span>
          </div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-224">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.15
        }} className="bg-brand-light p-8 rounded-2xl border border-gray-200 shadow-sm flex flex-col" data-id="element-225">
              <div className="flex text-brand-gold mb-6" data-id="element-226">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-current" data-id="element-227" />)}
              </div>
              <p className="text-gray-700 text-lg leading-relaxed mb-8 flex-grow italic" data-id="element-228">
                "{review.quote}"
              </p>
              <div className="border-t border-gray-200 pt-4" data-id="element-229">
                <p className="font-bold text-brand-dark" data-id="element-230">{review.author}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}